import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const store = createPinia();

store.use(piniaPluginPersistedstate);

export default store;

// export * from './modules/chat';
export * from './modules/agent';
export * from './modules/connector';
export * from './modules/design';
export * from './modules/devTools';
export * from './modules/notification';
export * from './modules/task';
export * from './modules/user';
export * from './modules/workspace';
